<template>
  <sameday-item-card :params="params">
    <sameday-loading />
  </sameday-item-card>
</template>

<script>
import SamedayItemCard from "@/components/Sameday/SamedayItemCard.vue";
import SamedayLoading from "@/components/Sameday/Loading/LoadingServices.vue";

export default {
  components: {
    SamedayItemCard,
    SamedayLoading,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
